// extracted by mini-css-extract-plugin
export var container = "_dt-0";
export var popoverContent = "_dt-1";
export var tosLink = "_dt-2";